<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="col-xl-6 col-md-6 col-12 d-flex">
            <button class="btn btn-primary" rippleEffect (click)="showCreateEnvironmentalCondition()">
                <i data-feather="plus" class="d-sm-none d-inline-block"></i>
                <span class="d-none d-sm-inline-block">Tanım Ekle</span>
            </button>
        </div>

        <div class="col-xl-6 col-md-6 col-12 d-flex justify-content-end align-items-center">
            <label class="d-flex align-items-center">
                <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="50">50</option>
                </select>
            </label>
        </div>
    </div>

    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true">

        <ngx-datatable-column name="Ortam Şartı" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
                <span *ngIf="row.enviromentalContent?.length > 0; else noData">
                    {{ formatEnvironmentalContent(row.enviromentalContent) }}
                </span>
                <ng-template #noData>
                    <span>Veri Yok</span>
                </ng-template>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Tür" [width]="200" prop="typeName"></ngx-datatable-column>

        <ngx-datatable-column name="#" [width]="75" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                    <!-- stopPropagation burada ekleniyor -->
                    <button class="btn btn-icon btn-flat-warning" (click)="showUpdateEnvironmetnalContent(row.id)">
                        <span data-feather="edit"></span>
                    </button>
                    <!-- <button class="btn btn-icon btn-flat-danger" appDelete [id]="row.id"
                        controller="EnvironmentalCondition"
                        (callback)="getAllEnvironmentalCondition(this.pageBasic - 1, this.selectedSize)">
                        <span [data-feather]="'trash'"></span>
                    </button> -->
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)" [maxSize]="5">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>